module.exports = new __parcel__URL__("activeUser.8e1c72e1.svg").toString();